import { render, staticRenderFns } from "./TicketTypeDesc.vue?vue&type=template&id=2f079964&scoped=true&"
import script from "./TicketTypeDesc.vue?vue&type=script&lang=js&"
export * from "./TicketTypeDesc.vue?vue&type=script&lang=js&"
import style0 from "./TicketTypeDesc.vue?vue&type=style&index=0&id=2f079964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f079964",
  null
  
)

export default component.exports